import { useMemo, useState } from 'react';

import LanguageContext from './LanguageContext.js';

export interface LanguageProviderProps {
  children: React.ReactNode;
  defaultLocale?: string;
  locales: Record<string, Record<string, string>>;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({
  children,
  locales,
  defaultLocale,
}) => {
  const [locale, setLocale] = useState<string | null>(null);

  const value = useMemo(
    () => ({
      setLocale,
      defaultLocale,
      locale,
      locales,
    }),
    [defaultLocale, locales, locale]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};
